<template>
    <div>
        <div  class="contents">
            <span @click="Delivercont(treedata.id,treedata.name)">{{treedata.name}}</span>
            <span v-if="isOpenFolder" @click="toggle">[{{open? '-':'+' }}]</span>
        </div>
        <ul v-if="isOpenFolder" v-show="open" class="childreens" >
            <Itreem v-for="item in treedata.children" :key="item.name" :treedata="item"></Itreem>
        </ul>
    </div>
</template>

<script>

export default {
    name:'Itreem',
    props:{
        treedata:{
            type:Object,
            required:true
        }
    },
    computed:{
        isOpenFolder(){
            return this.treedata.children && this.treedata.children.length;
        }
    },
    data(){
        return{
            open:true,
            dep_id:''
        }
    },
    methods:{
        toggle(){
            if(this.isOpenFolder){
                this.open = !this.open
            }
        },
        Delivercont(id){
            console.log(id,this.$parent.show2)
            this.dep_id = id
            // this.$parent.yy()
            // this.$parent.show2 = false
            // this.$parent.dept_id = id
        }
    }
}
</script>

<style scoped>
.contents{
    text-align: left;
    width: 100%;
    height: 40px;
    line-height: 40px;
    border-bottom:1px solid #cccccc;
}
.childreens{
    padding-left: 40px;
}
.contents{
    padding-left: 40px;
}
</style>